// extracted by mini-css-extract-plugin
module.exports = {"button":"language-button_button__a6UNu"};